import { GameName } from './components/GameName';
import { GameLabels } from './components/GameLabels';
import { GameJackpot } from './components/GameJackpot';
import { GameProvider } from './components/GameProvider';
import { GameMoreInfo } from './components/GameMoreInfo';
import { GameDemoButton } from './components/GameDemoButton';
import { GamePlayButton } from './components/GamePlayButton';
import { GameLiveLimits } from './components/GameLiveLimits';
import { GameCustomField } from './components/GameCustomField';
import { GameFavoriteIcon } from './components/GameFavoriteIcon';
import { GameLiveLanguage } from './components/GameLiveLanguage';
import { GameLiveOpenDate } from './components/GameLiveOpenDate';
import { GameLiveDealerName } from './components/GameLiveDealerName';
import { GameLivePlayersNumber } from './components/GameLivePlayersNumber';

export const components = {
    'hub2-game-name': GameName,
    'hub2-game-labels': GameLabels,
    'hub2-language': GameLiveLanguage,
    'hub2-provider-name': GameProvider,
    'hub2-game-limits': GameLiveLimits,
    'hub2-game-info-icon': GameMoreInfo,
    'hub2-jackpot-counter': GameJackpot,
    'hub2-custom-field': GameCustomField,
    'hub2-dealer-name': GameLiveDealerName,
    'hub2-game-demo-button': GameDemoButton,
    'hub2-game-play-button': GamePlayButton,
    'hub2-add-to-favorites': GameFavoriteIcon,
    'hub2-players-number': GameLivePlayersNumber,
    'hub2-game-live-open-date': GameLiveOpenDate
};
